<template>
  <div :class="$b()">
    <VisionModal
      :open="modalVisible"
      :max-modal-width="650"
      @close="$emit('toggle-frame-selector-modal-visible', false)"
    >
      <div
        :class="$b('modal-body')"
      >
        <div :class="$b('modal-select')">
          <FrameTypeSelectTabs
            :customised-product="customisedProduct"
            :hide-conversion-kit="customisedProduct.product.pageMode !== 'custom'"
            view="full"
          />
        </div>

        <AddToBag
          :price="price"
          :customised-product="customisedProduct"
          :pre-discount-price="preDiscountPrice"
          tracking-location="frameTypeSelectorModal"
        />

        <div
          :class="$b('continue-shopping')"
        >
          <VisionLink
            line-link
            is-button
            @click="$emit('toggle-frame-selector-modal-visible', false)"
          >
            Continue Shopping
          </VisionLink>
        </div>
      </div>
    </VisionModal>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'

export default {
  name: 'FrameTypeSelectModal',

  props: {
    customisedProduct: { type: CustomisedProduct, required: true },
    hideConversionKit: { type: Boolean, required: true },
    modalVisible: { type: Boolean, default: false },
    price: { type: Number, required: true },
  },

  emits: ['change', 'add-to-cart', 'toggle-frame-selector-modal-visible'],
}
</script>

<style lang="postcss" scoped>
.FrameTypeSelectModal__continue-shopping {
  @apply flex justify-center my-6 text-xxs;
}

.FrameTypeSelectModal__modal-body {
  @apply px-4 sm:px-6 mt-16;
}
</style>